import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuraLayout, Layout, Navbar } from "lola-framework-ui-test";
import { useStore } from "../store/globalState";
import { flavorClassName } from "../constants";
import { LEGAL_DOC_KEYS, type LegalDocKey } from "../constants/legal";
import { LegalAccordion } from "../components/legal/LegalAccordion";
import { LegalContent } from "../components/legal/LegalContent";
import { NavbarBackChevron } from "../components/NavbarBackChevron";
import "../styles/legal.style.css";

export const LegalPage = () => {
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const docParam = searchParams.get("doc") as LegalDocKey | null;
  const excludeParam = searchParams.get("exclude") as LegalDocKey | null;

  const filteredDocs = excludeParam
    ? LEGAL_DOC_KEYS.filter((k) => k !== excludeParam)
    : LEGAL_DOC_KEYS;

  const title = docParam ? t(`legal.docs.${docParam}`) : t("legal.title");

  return (
    <AuraLayout
      colorConfig={colorConfig}
      className={`legal-page ${flavorClassName}`}
    >
      <Layout.Header>
        <NavbarBackChevron onBackClick={() => navigate(-1)}>
          <Navbar
            className="legal-navbar"
            onBackClick={() => navigate(-1)}
            title={title}
            align="center"
          />
        </NavbarBackChevron>
      </Layout.Header>
      <Layout.Content isOverflowauto>
        <section className="legal-wrapper">
          {docParam ? (
            <LegalContent doc={docParam} />
          ) : (
            <LegalAccordion docs={filteredDocs} />
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
};
